export { default } from './MonthlyHistogramContainer';
